    <div class="modal-header">
        <h4 class="modal-title">Timebudget Detaljer : {{ month + '-' + year }} </h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th class="text-end">Kundenr</th>
                        <th>Navn</th>
                        <th class="text-end">Sagsnr</th>
                        <th>Sag</th>
                        <th class="text-end">Timer</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of plantid">
                        <td class="text-end">{{ item.kundeNr }}</td>
                        <td>{{ item.kundeNavn }}</td>
                        <td class="text-end">{{ item.sagsId }}</td>
                        <td>{{ item.sagsNavn }}</td>
                        <td class="text-end">{{ item.timer | time }}</td>
                    </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                    <th>Total</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-end">{{hoursTotal() | time}}</th>
                </tfoot>
            </table>
        </div>
    </div>
